import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'select',
    'proposalRow',
    'viewModeCount',
    'contentRow',
    'descriptionRow',
    'viewModeTh',
    'viewModeTd',
    'boardForm',
    'mixRadio',
    'secretRow',
    'secret',
    'typeInput',
    'viewModeCountFstInput',
    'viewModeCountSndInput',
    'viewModeCountSndLabel',
    'viewModeCountTrd',
    'viewModeCountTrdInput',
    'viewModeCountTrdLabel',
    'viewModeCountFth',
    'viewModeCountFthInput',
    'viewModeCountFthLabel',
    'memberRadio',
  ];

  static values = {
    viewMode: String,
    viewModeCount: String,
  };

  connect() {
    this.change();

    this.setViewModeCount(this.viewModeCountValue);
  }

  change() {
    switch (this.selectTarget.value) {
      case 'PROPOSAL':
        this.defaultForm();
        this.proposalForm();
        break;
      case 'NEWS':
        this.defaultForm();
        this.newsForm();
        break;
      case 'MEET':
        this.defaultForm();
        this.meetForm();
        break;
      case 'INTRO':
        this.defaultForm();
        this.introForm();
        break;
      case 'SECRET':
        this.defaultForm();
        this.secretProposalForm();
        break;
      default:
        this.defaultForm();
    }
  }

  defaultForm() {
    console.log('test', this.memberRadioTarget);
    this.proposalRowTarget.classList.add('hidden');
    this.contentRowTarget.classList.add('hidden');
    this.descriptionRowTarget.classList.remove('hidden');
    this.viewModeCountTarget.classList.remove('hidden');
    this.viewModeTdTarget.classList.add('hidden');
    this.viewModeThTarget.classList.add('hidden');
    this.mixRadioTarget.classList.add('hidden');
    this.secretRowTarget.classList.add('hidden');
    this.secretTarget.value = 'false';
    this.typeInputTarget.value = this.selectTarget.value;
    this.memberRadioTarget.classList.remove('hidden');
    this.setViewModeCountText(3, 6, 9);
    this.checkedViewModeCount(this.viewModeCountSndInputTarget);
  }

  proposalForm() {
    this.proposalRowTarget.classList.remove('hidden');
    this.viewModeTdTarget.classList.remove('hidden');
    this.viewModeThTarget.classList.remove('hidden');
    this.mixRadioTarget.classList.add('hidden');
    this.secretRowTarget.classList.remove('hidden');
  }

  secretProposalForm() {
    this.secretTarget.value = 'true';
    this.typeInputTarget.value = 'PROPOSAL';
    this.checkedViewModeCount(this.viewModeCountFstInputTarget);
  }

  newsForm() {
    this.viewModeTdTarget.classList.remove('hidden');
    this.viewModeThTarget.classList.remove('hidden');
    this.mixRadioTarget.classList.remove('hidden');
    this.selectViewMode(this.viewModeValue);
  }

  meetForm() {
    this.setViewModeCountText(2, 4, 6);
  }

  introForm() {
    this.descriptionRowTarget.classList.add('hidden');
    this.contentRowTarget.classList.remove('hidden');
    this.viewModeTdTarget.classList.add('hidden');
    this.viewModeThTarget.classList.add('hidden');
    this.viewModeCountSndInputTarget.value = 1;
    this.viewModeCountSndLabelTarget.innerHTML = '노출';
    this.viewModeCountTrdTarget.classList.add('hidden');
    this.viewModeCountFthTarget.classList.add('hidden');
    this.memberRadioTarget.classList.add('hidden');
  }

  changeViewMode(e) {
    if (this.selectTarget.value !== 'NEWS') {
      return;
    }
    this.selectViewMode(e.target.value);
  }

  selectViewMode(value) {
    switch (value) {
      case 'LIST':
      case 'MIXED':
        this.setViewModeCountText(4, 8, 12);
        break;
      default:
        this.setViewModeCountText(5, 9, 13);
    }
  }

  setViewModeCountText(sndText, trdText, fthText) {
    this.viewModeCountSndInputTarget.value = sndText;
    this.viewModeCountSndLabelTarget.innerHTML = sndText;
    this.viewModeCountTrdInputTarget.value = trdText;
    this.viewModeCountTrdLabelTarget.innerHTML = trdText;
    this.viewModeCountFthInputTarget.value = fthText;
    this.viewModeCountFthLabelTarget.innerHTML = fthText;
  }

  save() {
    this.selectTarget.disabled = false;
    this.boardFormTarget.submit();
  }

  checkedViewModeCount(target) {
    if (this.viewModeCountValue !== '') {
      return;
    }
    target.checked = true;
  }

  setViewModeCount(value) {
    if (value === '') {
      return;
    }
    const radioBtn = document.querySelector(`input[name="viewModeCount"][value="${value}"]`);
    radioBtn.checked = true;
  }
}
